import React, {
    forwardRef,
    useEffect,
    useImperativeHandle,
    useState,
} from "react";
import {User} from "react-feather";
import {FORMS, MODULES} from "../../const";
import LoadingSpinner from "../LoadingSpinner";
import Input from "../input/Input";
import Dropdown from "../input/Dropdown";
import InfoList from "../InfoList";
import {formatFromJsonDate} from "../../dateConfig";
import {alertNotificationValidation} from "../validations/AlertNotificationCreation";

const FORM = FORMS.ALERTS.ALR.form;
const AlertAddComponent = forwardRef(
    ({errors, dropdown, isLoading, currentValues, editMode}, ref) => {

        const [alertData, setAlertData] = useState(
            editMode
                ? {
                    ...currentValues,
                    nodId: currentValues.nodId,
                }
                : {
                    nodCode: "",
                    nodReference: "",
                    trlTransporter: "",
                    nodStaCode: "",
                    nodDefaultId: "",
                    nodDescription: "",
                    nodAlertType: "",
                    nodStatus: 2,
                    nodActive: 1,
                },
        );
        const [currentErrors, setCurrentErrors] = useState({});
        useEffect(() => {
            setCurrentErrors(errors);
        }, [errors]);

        // useEffect(() => {
        //     setAlertData(prevState => ({
        //         ...prevState,
        //         nodStaCode: dropdown.staCodeMap[prevState.nodStaCodeId]
        //     }))
        // }, [alertData.nodStaCodeId]);

        useEffect(() => {
            setAlertData((prevState) => ({
                ...prevState,
                nodStaCode: prevState.nodStaCodeId
                    ? dropdown.staCodeMap[prevState.nodStaCodeId]
                    : "",
            }));
        }, [alertData.nodStaCodeId]);


        useImperativeHandle(ref, () => ({
            getData: () => alertData,
            validateForm: () => {
                console.log("Alert Data", alertData);
                return alertNotificationValidation(alertData);
            },
            resetForm: () => {
                setAlertData({
                    nodCode: "",
                    nodReference: "",
                    trlTransporter: "",
                    nodStaCode: "",
                    nodDefaultId: "",
                    nodDescription: "",
                    nodAlertType: "",
                    nodStatus: 2,
                    nodActive: 1,
                });
            },
        }));


        return (
            <>
                {isLoading ? (
                    <LoadingSpinner/>
                ) : (
                    <form
                        className="ui form"
                        style={{overflowY: "auto", height: "75vh"}}
                    >
                        <div className="ui segment">
                            <h4 className="ui dividing header">Alerts</h4>
                            <div className="two fields">
                                <Input
                                    label="Alert Code"
                                    module={MODULES.Admin}
                                    form={FORM}
                                    field="nod_code"
                                    editMode={editMode}
                                    error={currentErrors.nodCode}
                                    resetError={() =>
                                        setCurrentErrors((prevState) => {
                                            const {nodCode: _, ...rest} = prevState;
                                            return rest;
                                        })
                                    }
                                    name="alertCode"
                                    value={alertData.nodCode}
                                    onChange={(e) => {
                                        setAlertData((prevState) => ({
                                            ...prevState,
                                            nodCode: e.target.value,
                                        }));
                                    }}
                                    disabled={true}
                                />


                                {/*<Input*/}
                                {/*    label="Alert Reference"*/}
                                {/*    placeholder="alert reference"*/}
                                {/*    module={MODULES.Admin}*/}
                                {/*    form={FORM}*/}
                                {/*    field="nod_reference"*/}
                                {/*    editMode={editMode}*/}
                                {/*    error={currentErrors.nodReference}*/}
                                {/*    resetError={() =>*/}
                                {/*        setCurrentErrors((prevState) => {*/}
                                {/*            const {nodReference: _, ...rest} = prevState;*/}
                                {/*            return rest;*/}
                                {/*        })*/}
                                {/*    }*/}
                                {/*    name="alertReference"*/}
                                {/*    value={alertData.nodReference}*/}
                                {/*    onChange={(e) => {*/}
                                {/*        setAlertData((prevState) => ({*/}
                                {/*            ...prevState,*/}
                                {/*            nodReference: e.target.value,*/}
                                {/*        }));*/}
                                {/*    }}*/}
                                {/*/>*/}
                            </div>
                            <div className="two fields">
                                <Input
                                    label="Description"
                                    placeholder="alert description"
                                    module={MODULES.Admin}
                                    form={FORM}
                                    field="nod_description"
                                    editMode={editMode}
                                    error={currentErrors.nodDescription}
                                    resetError={() =>
                                        setCurrentErrors((prevState) => {
                                            const {nodDescription: _, ...rest} = prevState;
                                            return rest;
                                        })
                                    }
                                    name="alertReference"
                                    value={alertData.nodDescription}
                                    onChange={(e) => {
                                        setAlertData((prevState) => ({
                                            ...prevState,
                                            nodDescription: e.target.value,
                                        }));
                                    }}
                                />
                                <Dropdown
                                    required={true}
                                    label="Notification Status Code"
                                    error={currentErrors.nodStaCode}
                                    editMode={editMode}
                                    module={MODULES.Admin}
                                    form={FORM}
                                    field="nod_sta_code"
                                    resetError={() =>
                                        setCurrentErrors((prevState) => {
                                            const {nodStaCode: _, ...rest} = prevState;
                                            return rest;
                                        })
                                    }
                                    options={dropdown.statusCodeOpt}
                                    style={{height: "20px"}}
                                    placeholder="Status Code"
                                    value={alertData.nodStaCodeId}
                                    onChange={(e, data) =>
                                        setAlertData((prev) => ({
                                            ...prev,
                                            nodStaCodeId: data.value,
                                        }))
                                    }
                                />
                            </div>
                            <div className="two fields">
                                <Dropdown
                                    required={true}
                                    label="Alert Type"
                                    error={currentErrors.nodAlertType}
                                    editMode={editMode}
                                    module={MODULES.Admin}
                                    form={FORM}
                                    field="nod_alert_type"
                                    resetError={() =>
                                        setCurrentErrors((prevState) => {
                                            const {nodAlertType: _, ...rest} = prevState;
                                            return rest;
                                        })
                                    }
                                    options={dropdown.alertTypeOpt}
                                    style={{height: "20px"}}
                                    placeholder="Alert Type"
                                    value={alertData.nodAlertType}
                                    onChange={(e, data) =>
                                        setAlertData((prev) => ({
                                            ...prev,
                                            nodAlertType: data.value,
                                        }))
                                    }
                                />
                                <Dropdown
                                    required={true}
                                    label="Default Selected Type"
                                    error={currentErrors.nodDefaultId}
                                    editMode={editMode}
                                    module={MODULES.Admin}
                                    form={FORM}
                                    field="nod_default_id"
                                    resetError={() =>
                                        setCurrentErrors((prevState) => {
                                            const {nodDefaultId: _, ...rest} = prevState;
                                            return rest;
                                        })
                                    }
                                    options={dropdown.defaultTypeOpt}
                                    style={{height: "20px"}}
                                    placeholder="Selected Type"
                                    value={alertData.nodDefaultId}
                                    onChange={(e, data) =>
                                        setAlertData((prev) => ({
                                            ...prev,
                                            nodDefaultId: data.value,
                                        }))
                                    }
                                />
                            </div>
                            <div className="two fields">
                                <Dropdown
                                    required={true}
                                    label="Status"
                                    module={MODULES.Admin}
                                    form={FORM}
                                    field="nod_status"
                                    editMode={editMode}
                                    error={currentErrors.nodStatus}
                                    resetError={() =>
                                        setCurrentErrors((prevState) => {
                                            const {nodStatus: _, ...rest} = prevState;
                                            return rest;
                                        })
                                    }
                                    placeholder="Status"
                                    options={dropdown.alertStatusOpt}
                                    value={alertData.nodStatus}
                                    style={{height: "20px"}}
                                    onChange={(e, data) => {
                                        setAlertData((prevState) => ({
                                            ...prevState,
                                            nodStatus: data.value,
                                        }));
                                    }}
                                />
                                <Dropdown
                                    required={true}
                                    label="Active"
                                    module={MODULES.Admin}
                                    form={FORM}
                                    field="nod_active"
                                    editMode={editMode}
                                    error={currentErrors.nodActive}
                                    resetError={() =>
                                        setCurrentErrors((prevState) => {
                                            const {nodActive: _, ...rest} = prevState;
                                            return rest;
                                        })
                                    }
                                    placeholder="Active"
                                    options={dropdown.alertActiveOpt}
                                    value={alertData.nodActive}
                                    style={{height: "20px"}}
                                    onChange={(e, data) => {
                                        setAlertData((prevState) => ({
                                            ...prevState,
                                            nodActive: data.value,
                                        }));
                                    }}
                                />
                            </div>
                        </div>
                        {editMode && (
                            <InfoList
                                title="User Information"
                                content={[
                                    {
                                        title: "Created By",
                                        value: alertData.createdBy
                                            ? alertData.createdBy
                                            : "N/A",
                                    },
                                    {
                                        title: "Created Date",
                                        value: alertData.createdDate
                                            ? formatFromJsonDate(alertData.createdDate)
                                            : "N/A",
                                    },
                                    {
                                        title: "Last Modified By",
                                        value: alertData.lastModifiedBy
                                            ? alertData.lastModifiedBy
                                            : "N/A",
                                    },
                                    {
                                        title: "Last Modified Date",
                                        value: alertData.lastModifiedDate
                                            ? formatFromJsonDate(alertData.lastModifiedDate)
                                            : "N/A",
                                    },
                                ]}
                                Icon={User}
                            />
                        )}
                    </form>
                )}
            </>
        );
    },
);

export default AlertAddComponent;
